import { useRef } from 'react';

export const useEnter = () => {
  const ref: React.MutableRefObject<any> = useRef(null);
  const handleEnter = (e: React.KeyboardEvent<HTMLFormElement>): void =>
    e.keyCode === 13 ? ref.current?.click() : undefined;
  return { ref, handleEnter };
};
